import useOrganizationName from '@/hooks/useOrganizationName';
import api from '@/services/api';
import {
  keepPreviousData,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import { useEffect } from 'react';
import { GetReservationsProps } from './useGetPaginatedReservation';


const getQueryOptions = ({
  pagination,
  filtering,
  sorting,
  columnFilters,
  organizationName,
  query
}: GetReservationsProps) => {
  return {
    queryKey: [
      'reservations',
      pagination,
      { search: filtering },
      sorting,
      columnFilters,
      organizationName,
      query
    ],
    refetchInterval: 100 * 5000,
    refetchOnReconnect: true,
    queryFn: () =>
      api.reservations.getPaginatedPendingActions({
        pagination,
        filtering,
        sorting,
        columnFilters,
        query
      })
  };
};

const useGetPaginatedPendingActions = (props: GetReservationsProps) => {
  const queryClient = useQueryClient();
  const organizationName = useOrganizationName();

  //prefetch next page
  useEffect(() => {
    queryClient.prefetchQuery(
      getQueryOptions({
        ...props,
        organizationName,
        pagination: {
          ...props.pagination,
          pageIndex: props.pagination.pageIndex + 1
        }
      })
    );
  }, [queryClient, props, organizationName]);

  return useQuery({
    ...getQueryOptions({ ...props, organizationName }),

    placeholderData: keepPreviousData
  });
};

export default useGetPaginatedPendingActions;
